import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Status } from '../_models/status';

@Injectable({
  providedIn: 'root'
})
export class StatusService {
  updateStatusData = new BehaviorSubject<Status>(null);

  constructor(
    private http: HttpClient
  ) { }

  getAllStatus(){
    return this.http.get<Status[]>(`${environment.apiUrl}/api/statuses`)
    .pipe(map(responseData =>{
      return responseData;
    })
    )
  }

  deleteStatus(partnerId: number){
    return this.http.delete(`${environment.apiUrl}/api/statuses/${partnerId}`);
  }

  updateStatus(statusId:number, status: Status){
    return this.http.patch<Status>(`${environment.apiUrl}/api/statuses/${statusId}`,status);
  }

  addStatus(status: Status){
    return this.http.post<Status>(`${environment.apiUrl}/api/statuses`,status);
  }

}
